import { useQuery } from '@apollo/client'
import debounce from 'lodash/debounce'
import { FC, useCallback } from 'react'
import { FieldValidator } from 'final-form'
import {
  searchTeamMember,
  searchTeamMember_searchTeamMember_items as SearchedTeamMember,
  searchTeamMemberVariables,
} from '__generatedTypes__/searchTeamMember'
import { SEARCH_TEAM_MEMBER } from 'queries/teamMember'
import { DEBOUNCE_DELAY } from 'constants/consts'
import { AutosuggestField } from 'components/Autosuggest'
import { AuthorRenderItem } from './AuthorRenderItem'

type Props = {
  name: string
  label?: string
  validate?: FieldValidator<SearchedTeamMember[]>
}

export const AuthorSearch: FC<Props> = ({ name, label, validate }) => {
  const teamMembersState = useQuery<searchTeamMember, searchTeamMemberVariables>(SEARCH_TEAM_MEMBER)

  const handleTeamMemberInputChange = useCallback(
    debounce((searchString: string) => {
      teamMembersState.refetch({
        searchString,
      })
    }, DEBOUNCE_DELAY),
    []
  )

  return (
    <AutosuggestField<SearchedTeamMember>
      name={name}
      label={label}
      validate={validate}
      items={teamMembersState.data?.searchTeamMember.items || []}
      onInputChange={handleTeamMemberInputChange}
      getItemLabel={(author) => author.fullName}
      renderItem={(author) => <AuthorRenderItem author={author} />}
      placeholder="Search Author"
      searchable
      withoutCheckMark
      fullWidth
    />
  )
}
